export const removeDoubleSlashes = (url: string) => url.replace(/([^:]\/)\/+/g, '$1')
